var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconSearchBlue(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.2929 13.7071C12.6834 14.0976 13.3166 14.0976 13.7071 13.7071C14.0976 13.3166 14.0976 12.6834 13.7071 12.2929L12.2929 13.7071ZM7.90504 9.31925L12.2929 13.7071L13.7071 12.2929L9.31925 7.90504L7.90504 9.31925ZM5.535 11.07C8.59167 11.07 11.07 8.59147 11.07 5.53429H9.07C9.07 7.4871 7.4869 9.07 5.535 9.07V11.07ZM11.07 5.53429C11.07 2.47822 8.59137 0 5.53429 0V2C7.48721 2 9.07 3.5832 9.07 5.53429H11.07ZM5.53429 0C2.47843 0 0 2.47772 0 5.535H2C2 3.58228 3.583 2 5.53429 2V0ZM0 5.535C0 8.59147 2.47761 11.07 5.535 11.07V9.07C3.58239 9.07 2 7.4871 2 5.535H0Z",
    fill: "#004FEC"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSearchBlue);
export default __webpack_public_path__ + "static/media/icon_search_blue.959334b4be5e18537adf37c6298b8954.svg";
export { ForwardRef as ReactComponent };